var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.88 20.92C15.91 21.08 15.82 21.25 15.67 21.31C14.54 21.76 13.3 22 12.02 22C9.80999 22 7.76997 21.29 6.11997 20.07C5.97997 19.97 5.94 19.77 6.03 19.62C6.58 18.64 8.72995 15.49 13.48 13.73C13.66 13.66 13.86 13.75 13.92 13.93C15.11 17.12 15.67 19.82 15.88 20.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.82 13.89C21.36 16.35 19.98 18.49 18.05 19.95C17.84 20.11 17.54 19.99 17.49 19.74C17.28 18.66 16.77 16.33 15.79 13.56C15.72 13.35 15.86 13.12 16.08 13.09C18.57 12.79 20.75 13.27 21.57 13.49C21.74 13.55 21.85 13.72 21.82 13.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5901 11.82C20.5701 11.64 17.97 11.26 15.31 11.55C15.15 11.57 15.01 11.48 14.94 11.33C14.9 11.24 14.87 11.15 14.83 11.06C14.67 10.69 14.5 10.31 14.33 9.93999C14.24 9.75999 14.33 9.53998 14.51 9.45998C17.31 8.24998 18.87 6.68998 19.48 5.98998C19.63 5.81998 19.8901 5.83 20.0301 6.01C21.1801 7.54 21.89 9.40998 22 11.43C22.01 11.68 21.8101 11.86 21.5901 11.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.44 4.79001C17.92 5.42001 16.46 6.91999 13.69 8.01999C13.53 8.08999 13.34 8.01999 13.25 7.85999C11.97 5.53999 10.61 3.58999 9.98 2.70999C9.83 2.49999 9.95003 2.2 10.2 2.16C10.78 2.06 11.39 2.01001 12.01 2.01001C14.43 2.01001 16.66 2.87 18.39 4.31C18.54 4.42 18.56 4.64001 18.44 4.79001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.02 8.84C7.23002 9.79 3.87998 9.92001 2.65998 9.94001C2.42998 9.94001 2.26001 9.72001 2.32001 9.50001C3.04001 6.70001 4.95999 4.36001 7.48999 3.07001C7.63999 2.99001 7.83 3.04 7.93 3.18C8.45 3.9 9.85999 5.93001 11.24 8.32001C11.35 8.52001 11.25 8.78 11.02 8.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.92 11.6C13.01 11.79 12.9 12.02 12.7 12.09C8.27001 13.52 5.62001 17.07 4.82001 18.29C4.69001 18.49 4.41001 18.5 4.26001 18.32C2.86001 16.6 2.01001 14.63 2.01001 12.24V12.06C2.01001 11.86 2.17 11.7 2.37 11.71C3.63 11.76 7.74001 11.59 12.01 10.36C12.17 10.31 12.35 10.39 12.42 10.54C12.59 10.89 12.76 11.24 12.92 11.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/Sport.7b30bbd7f8ca13b9b6e371db5f508bbf.svg";
export { ForwardRef as ReactComponent };